import React, { useState, useCallback, memo } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import classnames from 'classnames/bind';
import { Modal } from '@miroculus/miroculus-ui';
import styles from './Layout.scss';
import { Header } from 'containers';
import { Spinner, Sidebar } from 'components';
import { hideModal } from 'reduxModules/ui/layout';
import { getCurrentModal } from 'reduxModules/ui/selectors';
import { getLoading } from 'reduxModules/auth/selectors';

const cx = classnames.bind(styles);

export function Layout({ children }) {
  const dispatch = useDispatch();
  // location is available via useLocation if needed in the future
  // const location = useLocation();

  const loading = useSelector(getLoading);
  const currentModal = useSelector(getCurrentModal);

  const [sidebarOpen, setSidebarOpen] = useState(true);

  const handleSidebarClose = useCallback(() => {
    setSidebarOpen((prev) => !prev);
  }, []);

  const handleHideModal = useCallback(() => {
    dispatch(hideModal());
  }, [dispatch]);

  return (
    <div className={cx('container')}>
      <div>
        <Sidebar open={sidebarOpen} />
      </div>
      <div className={cx('body')}>
        <Header onSidebarClose={handleSidebarClose} />
        {!loading ? <div className={cx('main')}>{children}</div> : <Spinner />}
        {!!currentModal && (
          <div className={cx('modalContainer')}>
            <Modal onCloseButtonClick={handleHideModal}>{currentModal}</Modal>
          </div>
        )}
      </div>
    </div>
  );
}

Layout.propTypes = {
  children: PropTypes.node,
};

export default memo(Layout);
